/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module ExternalServicesModule */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlbHttpClient } from 'ng/modules/http/service/alb-http-client.service';
import { ITelemetryData } from './customer-program.service.types';

/**
 * @description Service for the telemetry data Customer Program page.
 * @author Shubam Bindal
 */
@Injectable()
export class CustomerProgramService {
    constructor(private readonly http: AlbHttpClient) {}

    /**
     * Fetch telemetry data.
     */
    public loadTelemetryData(): Observable<ITelemetryData> {
        const requestUrl = '/api/telemetry/data';

        return this.http.get<ITelemetryData>(requestUrl);
    }
}
